import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import OnTokenizeAndResumeHandlers from './onTokenizeAndResumeHandlers';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called when the resume token must be sent to your server to resume the payment flow, typically after the customer has completed some authorization step outside of the Primer SDK.`}</p>
    <Callout emoji='ℹ️' mdxType="Callout">
      <p>{`If you set `}<inlineCode parentName="p">{`paymentHandling`}</inlineCode>{` to `}<inlineCode parentName="p">{`MANUAL`}</inlineCode>{`, handling `}<inlineCode parentName="p">{`onResumeSuccess()`}</inlineCode>{` is required to fully support 3DS and the majority of payment methods.`}</p>
    </Callout>
    <Group summary='Parameters' mdxType="Group">
      <Item title="data" subtitle="ResumeToken" mdxType="Item">
        <Group summary='Properties' mdxType="Group">
          <Item title="resumeToken" subtitle="string" mdxType="Item">
            <p>{`The resume token you can use to `}<a parentName="p" {...{
                "href": "https://primer.io/docs/api/api-reference/payments-api/resume-payment"
              }}>{`resume the payment flow`}</a>{` on your backend.`}</p>
          </Item>
          <Item title='paymentId' subtitle='string' mdxType="Item">
	An unique identifier of the payment on Primer.
          </Item>
        </Group>
      </Item>
      <Item title='handler' subtitle='OnResumeSuccessHandler' mdxType="Item">
        <Group summary='Properties' mdxType="Group">
          <OnTokenizeAndResumeHandlers mdxType="OnTokenizeAndResumeHandlers" />
        </Group>
      </Item>
    </Group>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`You will receive a `}<inlineCode parentName="p">{`resumeToken`}</inlineCode>{` via the `}<inlineCode parentName="p">{`onResumeSuccess()`}</inlineCode>{` callback if applicable`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Send a `}<a parentName="p" {...{
            "href": "https://primer.io/docs/api/api-reference/payments-api/resume-payment"
          }}>{`resume payment request`}</a>{` with the `}<inlineCode parentName="p">{`resumeToken`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If the payment is successful, call `}<inlineCode parentName="p">{`handler.handleSuccess()`}</inlineCode>{` in order to display a success screen`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If the payment is unsuccessful, call `}<inlineCode parentName="p">{`handler.handleFailure(errorMessage)`}</inlineCode>{` to display an error or failure message`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The Payments API may again return a new `}<inlineCode parentName="p">{`clientToken`}</inlineCode>{` for additional steps. In this case, call `}<inlineCode parentName="p">{`handler.continueWithNewClientToken(clientToken)`}</inlineCode>{` again`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      